function getDefaultCreditCardDisplay(methods) {
  const defaultCard = Array.isArray(methods)
    ? methods.find((method) => method?.isDefault === true)
    : null;

  if (!defaultCard) {
    return null;
  }

  const bankNameShort = String(defaultCard.bankNameShort ?? '').trim();
  const bankName = String(defaultCard.bankName ?? '').trim();

  return {
    brandLabel: (bankNameShort || bankName || 'CARD').toUpperCase(),
    bankName,
    bankNameShort,
    lastFour: String(defaultCard.lastDigits ?? '').trim(),
    cardBackgroundURL: defaultCard.cardBackgroundURL || null,
    isExpired: defaultCard.isExpired === true
  };
}

export function resolveDefaultCreditCardState(methods, { loading = false, loaded = false } = {}) {
  if (loading) {
    return {
      loading: true,
      isUsable: false,
      showExpiredError: false,
      display: null
    };
  }

  if (!loaded) {
    return {
      loading: false,
      isUsable: false,
      showExpiredError: false,
      display: null
    };
  }

  const display = getDefaultCreditCardDisplay(methods);
  if (!display || display.isExpired) {
    return {
      loading: false,
      isUsable: false,
      showExpiredError: true,
      display
    };
  }

  return {
    loading: false,
    isUsable: true,
    showExpiredError: false,
    display
  };
}
